import React, { useMemo } from 'react'
import { Stack } from '@mui/material'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import { useSearchParams } from 'router'
import { useTranslation } from 'react-i18next'
import { useRegisterBreadcrumbAction } from 'components/AuthenticatedLayout/Header/components/BreadcrumbActions'

import HeaderExportButton from 'components/global/Buttons/HeaderExportButton'
import MainContent, { TableContent } from 'components-shared'

import { useSIPs } from './use-sips'
import { useSelection, useFilters } from './store'
import Status, { Type, Verbatim, Preferences } from './Filters'
import Table from './Table'
import { AlarmCardInMass } from './Alarm'

const Export = ({ onExport }) => {
  const { t } = useTranslation()

  const handleExport = () => {
    const content = onExport()
    const encodedUri = encodeURI(content)
    const link = document.createElement('a')
    link.setAttribute('href', encodedUri)
    link.setAttribute('download', `sips_${new Date().toLocaleDateString()}`)
    document.body.appendChild(link)// Required for FF

    link.click();
    document.body.removeChild(link)
  }
  return (
    <HeaderExportButton
      analyticsName="voip_sips"
      onClick={handleExport}
    >
      {t('export.button')}
    </HeaderExportButton>
  )
}

const SIPs = () => {
  const [searchParams] = useSearchParams()
  const [selection] = useSelection()
  const [filters, setFilters] = useFilters({
    statuses: searchParams.get('filter_status') ? [searchParams.get('filter_status') as string] : [],
    type: searchParams.get('filter_type') || 'room',
    preferences: searchParams.get('filter_preference') ? [searchParams.get('filter_preference') as string] : [],
  })
  const { loading, sips, statuses, preferences, types, onExport } = useSIPs()
  const exportAction = useMemo(() => <Export onExport={onExport} />, [onExport])

  useRegisterBreadcrumbAction(exportAction)

  return (
    <Stack flex={1}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <Stack direction={'row'} alignItems={'center'}>
          <Stack direction={'row'} gap={1} height={'100%'}>
            <Status values={filters.statuses} statuses={statuses} onChange={(values) => setFilters(prev => ({ ...prev, statuses: values }))} />
            <Preferences values={filters.preferences} preferences={preferences} onChange={(values) => setFilters(prev => ({ ...prev, preferences: values }))} />
            <Verbatim value={filters.verbatim} onChange={(value) => setFilters(prev => ({ ...prev, verbatim: value }))} />
          </Stack>
        </Stack>
        <Stack direction={'row'} gap={1}>
          <Type value={filters.type} types={types} loading={loading} onChange={(value) => setFilters(prev => ({ ...prev, type: value }))} />
        </Stack>
      </Stack>
      <MainContent>
        <TableContent>
          {
            loading
              ? <TableSkeleton />
              : <Table sips={sips} loading={loading} type={filters.type} />
          }
        </TableContent>
        {
          Boolean(selection.length) && <AlarmCardInMass />
        }
      </MainContent>
    </Stack>
  )
}

export default SIPs